import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Modal,
  Box,
  Card,
  CardContent,
  Typography
} from '@material-ui/core';
import { stylesheet } from '../../../Stylesheet';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles(theme => ({
  ...stylesheet,
  infoCard:{
    borderLeft: "4px solid  #1E69D2 !important",
    marginTop: "32px !important",
    marginBottom: "32px !important"
  },
  errorCard:{
    borderLeft: "4px solid #FF0000 !important",
    marginTop: "32px !important",
    marginBottom: "32px !important"
  },
  errorIcon: {
    color: '#FF0000',
    fontSize: '30px',
    float: 'left',
    marginRight: '20px' 
  },
  successIcon: {
    color: theme.palette.primary.main,
    fontSize: '30px',
    float: 'left',
    marginRight: '20px' 
  },
  infoIcon: {
    color: theme.palette.primary.main,
    fontSize: '30px',
    float: 'left',
    marginRight: '20px' 
  },
  cardContent: {
    display: 'block',
    float: 'left',
  },
  hidden: {
    display: 'none !important'
  },
  modal:{
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  inmodal:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '400px',
    minWidth: '200px',
    padding: theme.spacing(1)
  }
}));

export const InfoView = ({ children, onActionClick = i=>i }) => {
  const classes = useStyles();
  return (
      <Box className={classes.infoCard}>
        <Card>
          <CardContent  onClick={() => onActionClick()}>
            <InfoOutlinedIcon className={classes.infoIcon} />
            <div className={classes.cardContent}>
              <Typography color="text.secondary" >
                {children}
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Box>
  );
};

InfoView.propTypes = {
  message: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired
};

export const SuccessView = ({ children, onActionClick = i=>i }) => {
  const classes = useStyles();
  return (
      <Box className={classes.infoCard}>
        <Card>
          <CardContent  onClick={() => onActionClick()}>
            <CheckCircleOutlineIcon className={classes.successIcon} />
            <div className={classes.cardContent}>
              <Typography color="text.secondary" >
                {children}
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Box>
  );
};

InfoView.propTypes = {
  message: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired
};


export const ErrorView = ({ children, onActionClick = i=>i }) => {
  const classes = useStyles();
  return (
      <Box className={classes.errorCard}>
        <Card>
          <CardContent  onClick={() => onActionClick()}>
            <ErrorOutlineIcon className={classes.errorIcon} />
            <div className={classes.cardContent}>
              <Typography color="text.secondary" >
                {children}
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Box>
  );
};

InfoView.propTypes = {
  message: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired
};
/*
Hooks to simplify modal state
Try to use these unless you have more complex state for a particular page
*/

// usage: const [Modal, openModal] = useSuccessModal(message)
// openModal() or openModal(updatedMessage) to open the modal
// openModal(updatedMessage, onClose) to call 'onClose' when the modal is closed.
export const useInfoBanner = (message = '') => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(message);
  const classes = useStyles();
  return (
    [
      () =>
        <div className={open ? '' : classes.hidden}>
          <InfoView onActionClick={() => { setOpen(false); }} >{text}</InfoView>
        </div>,
      (newText = message) => { setText(newText); setOpen(true); }
    ]
  )
}

export const useSuccessBanner = (message = '') => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(message);
  const classes = useStyles();
  return (
    [
      () =>
        <div className={open ? '' : classes.hidden}>
          <SuccessView onActionClick={() => { setOpen(false); }} >{text}</SuccessView>
        </div>,
      (newText = message) => { setText(newText); setOpen(true); }
    ]
  )
}

export const useErrorBanner = (message = '') => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(message);
  const classes = useStyles();
  return (
    [
      () =>
        <div className={open ? '' : classes.hidden}>
          <ErrorView onActionClick={() => { setOpen(false); }} >{text}</ErrorView>
        </div>,
      (newText = message) => { setText(newText); setOpen(true); }
    ]
  )
}

export const useInfoModal = (message = '') => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(message);
  const classes = useStyles();
  return (
    [
      () => 
      <Modal open={open} className={classes.modal}>
        <div className={classes.inmodal}>
            <InfoView onActionClick={() => setOpen(false)} >{text}</InfoView>
        </div>
      </Modal>,
      (newText = message) => { setText(newText); setOpen(true);}
    ]
  )
}